module.exports = __webpack_public_path__ + "static/img/home-logo.899fb00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/street/home-logo.png
// module id = lmTf
// module chunks = 208